import styled from 'styled-components';

export const FormWrapper = styled.div`
  max-height: 100vh;
  overflow: hidden;
`;
